import React from 'react'
import glamorous from 'glamorous'
import Tooltip from 'antd/lib/tooltip'
import Table from 'antd/lib/table'
import Button from 'antd/lib/button'
import { Popover, Popconfirm, notification, Icon, Dropdown, Menu, Empty, Select } from 'antd';
import Modal from 'antd/lib/modal'
import Row from 'antd/lib/row'
import Col from 'antd/lib/col'
import get from 'lodash/fp/get'
import Input from 'antd/lib/input'
import message from 'antd/lib/message'

import reduce from "lodash/fp/reduce";
import flow from "lodash/fp/flow";
import map from "lodash/fp/map";
import flatMap from "lodash/fp/flatMap";
import find from "lodash/fp/find";
import debounce from "lodash/debounce";
import moment from "moment";
import { Link } from 'react-router-dom'
import { ROUTES } from '../../shared/constants'
import { SR_RET_Period_Query, CompanyQuery, GSTR1_Query, Supplier_View } from 'qgst-gql-queries/web/data.json'
import { gql, graphql, compose } from 'react-apollo'
import { connect } from 'react-redux'
import DropZone from 'react-dropzone'
import { Root, ContentWrapper as Content } from '../../shared/styles'
import SUPPLIERVIEW from '../../services/SupplierViewService'
import { BASE_URL } from '../../shared/constants'
import { gspActions } from "../../gspRedux";
import { formatNumber, getPlaceOfSupply } from "../../shared/constants";
import excelUtility from "../../services/excelUtilityService";


import {EXCEL_FILE_BASE64} from "./Template_excel"
import FileSaver from "file-saver"

const { Option } = Select;
const add_button = { outline: '0', display: 'inline-block', marginBottom: '0', fontWeight: '500', textAlign: 'center', touchAction: 'manipulation', cursor: 'pointer', backgroundImage: 'none', border: '1px solid transparent', whiteSpace: 'nowrap', lineHeight: '1.5', padding: '0 15px', fontSize: '13.5px', borderRadius: '5px', height: '34px', mozUserSelect: 'none', position: 'relative', color: '#000000a6', backgroundColor: 'rgb(49, 85, 111)', borderColor: '#d9d9d9', paddingTop: '5px' };
const row_style = { border: 'solid 1px #e8e8e8', padding: '10px', margin: '1px', textAlign: 'center' };
const button_style = { width: '200px' };
const edit_button = { outline: '0', display: 'inline-block', marginBottom: '0', marginRight: '5', fontWeight: '500', textAlign: 'center', touchAction: 'manipulation', cursor: 'pointer', backgroundImage: 'none', border: '1px solid transparent', whiteSpace: 'nowrap', lineHeight: '1.80', padding: '0 15px', fontSize: '12px', borderRadius: '5px', height: '33px', mozUserSelect: 'none', position: 'relative', color: '#000000a6', backgroundColor: 'rgb(74, 101, 121)', borderColor: '#d9d9d9', paddingTop: '5px', width: '70px' };
const user_button = { outline: '0', display: 'inline-block', marginBottom: '0', marginRight: '5', fontWeight: '500', textAlign: 'center', touchAction: 'manipulation', cursor: 'pointer', backgroundImage: 'none', border: '1px solid transparent', whiteSpace: 'nowrap', lineHeight: '1.80', padding: '0 15px', fontSize: '12px', borderRadius: '5px', height: '33px', mozUserSelect: 'none', position: 'relative', color: '#000000', backgroundColor: 'rgb(5, 112, 107)', borderColor: '#d9d9d9', paddingTop: '5px', width: '70px' };

var comp_id = '...'
const { Column } = Table
const SRow = glamorous(Row)({ margin: '15px 0', })
const confirm = Modal.confirm;
const scroll = { x: 1600 };
const actionButton = { paddingLeft: '0px', paddingRight: '0px' };
var fileSaver = require('file-saver')
var blob = require('blob-util')

const SalesRegister = props => {

  console.log(props, "salesre");

  function showConfirm() {
    confirm({
      title: 'Errors Found While Uploading Supplier Data',
      iconType: 'printer',
      width: 866,
      content: (<div id="dialogue_append1"></div>),
      onOk() {
        document.getElementById("sales_download").click();
        return new Promise((resolve, reject) => {
          setTimeout(Math.random() > 0.5 ? resolve : reject, 1000);
        }).catch(() => console.log('Oops errors!'));
      }
    });
  }
  function info() {
    Modal.info({
      title: 'This is a notification message',
      iconType: 'delete',
      width: 450,
      content: (
        <div>
          <p id="dynamic_error_msg"></p>
        </div>
      ),
      onOk() { },
    });
  }





  return (


    <Root>
      <Content>
        <SRow gutter={24} style={row_style}>
          <span>
            <Button size="large" className="{ant-btn-primary}" id="sales_download" >Download</Button>
          </span>
          <span> <Button id="sales_confirm_upload" onClick={showConfirm}></Button></span>

          <Col span="6">
            <p size="large" style={{ width: "180px", fontSize: '14px', padding: '0 10px', backgroundColor: 'white', color: 'black' }}><b>Bulk Upload Here</b></p>
          </Col>

          {!props.externalInterfaceInfo && (
            <Col span="5">
              <DropZone onDrop={props.onDropSR} multiple={false} disabled={props.role === 'reviewer'}>
                {({ getRootProps, getInputProps }) => (
                  <div {...getRootProps()}>
                    <input {...getInputProps()} />
                    <Tooltip title="Upload Supplier GST" overlay="">
                      <Button size="large" icon="cloud-upload" style={{ width: "180px", fontSize: '14px', padding: '0 10px', backgroundColor: '#2382c7', color: 'whiteReset' }} disabled={props.role === 'reviewer'}>
                        Bulk Upload
                      </Button>
                    </Tooltip>
                  </div>
                )}
              </DropZone>
            </Col>)}
          <Col span="4">
            <Tooltip title="Clear all Supplier GST list" overlay="">
              <Popconfirm placement="bottomRight" title="Clicking this button will reset all Supplier for selected Tax Period!" onConfirm={props.resetSales} okText="Yes" cancelText="No">
                <Button size="large" style={{ width: "180px", fontSize: '14px', padding: '0 10px', backgroundColor: '#a01208de', color: 'white' }} icon="safety" disabled={props.role === 'reviwer'} >Reset</Button>
              </Popconfirm>
            </Tooltip>
          </Col>
          <Col span="6">
            <Tooltip title="Download Supplier for selected Tax Period" overlay="">   
                  <Button size="large" style={{ width: "180px", fontSize: '14px', padding: '0 10px', backgroundColor: 'green', color: 'white' }} icon="cloud-download" disabled={props.role === 'reviewer'} target="_blank" onClick={props.handleDownload}>Download Template</Button> 
            </Tooltip>
          </Col>
        </SRow>
        <script type="text/javascript" src="FileSaver.js"></script>
      </Content>
      <Content>
        <Table title={props.SupplierTitle} dataSource={props.supplier} bordered rowKey="gstin">

          <Column title="Supplier GSTIN" size="large" dataIndex="vendor_gstin" key="vendor_gstin" className="alignCenter"
            filterDropdown={({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
              <div className="custom-filter-dropdown">
                <Input
                  placeholder="Search GSTN"
                  value={selectedKeys[0]}
                  onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                  onPressEnter={props.handleSearch(selectedKeys, confirm)}
                />
                <Button type="primary" onClick={props.handleSearch(selectedKeys, confirm)}>Search</Button>
                <Button id="gstnSearch" onClick={props.handleReset(clearFilters)}>Reset</Button>
              </div>
            )}
            filterIcon={filtered => <Icon type="search" style={{ color: filtered ? '#108ee9' : '#aaa' }} />}
            onFilter={(value, record) => record.vendor_gstin.toLowerCase().includes(value.toLowerCase())}
            render={(text) => {
              return props.searchText ? (
                <span>
                  {text.split(new RegExp(`(?<=${props.searchText})|(?=${props.searchText})`, 'i')).map((fragment, i) => (
                    fragment.toLowerCase() === props.searchText.toLowerCase()
                      ? <span key={i} className="highlight">{fragment}</span> : fragment // eslint-disable-line
                  ))}
                </span>
              ) : text;
            }}
          />
          <Column title="Supplier Name" size="large" dataIndex="vendor_gstname" key="vendor_gstname" className="alignCenter"
            filterDropdown={({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
              <div className="custom-filter-dropdown">
                <Input
                  placeholder="Search Company Name"
                  value={selectedKeys[0]}
                  onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                  onPressEnter={props.handleSearch(selectedKeys, confirm)}
                />
                <Button type="primary" onClick={props.handleSearch(selectedKeys, confirm)}>Search</Button>
                <Button id="gstnSearch" onClick={props.handleReset(clearFilters)}>Reset</Button>
              </div>
            )}
            filterIcon={filtered => <Icon type="search" style={{ color: filtered ? '#108ee9' : '#aaa' }} />}
            onFilter={(value, record) => record.vendor_gstname.toLowerCase().includes(value.toLowerCase())}
            render={(text) => {
              return props.searchText ? (
                <span>
                  {text.split(new RegExp(`(?<=${props.searchText})|(?=${props.searchText})`, 'i')).map((fragment, i) => (
                    fragment.toLowerCase() === props.searchText.toLowerCase()
                      ? <span key={i} className="highlight">{fragment}</span> : fragment // eslint-disable-line
                  ))}
                </span>
              ) : text;
            }}


          />
          <Column
            title="Actions"
            size="large"
            dataIndex="actions"
            key="actions"
            className="alignCenter"
            render={(text, record) => {

              return (
                <Col span={12}>
                  <Button
                    style={{ backgroundColor: "#437DA1", color: "white" }}
                    onClick={() => props.queryYEARPurchase(record)}
                  >
                    View
                  </Button>
                </Col>
              )
            }}
          />
        </Table>

        <Modal

          title="Please select Financial Year to proceed"
          visible={props.queryModal}
          onOk={props.queryYEAR}
          onCancel={props.queryYEAR_CANCEL}
        >
          <div style={{ textAlign: "center" }}>
            <Select
              defaultValue={props.finYear}
              style={{ width: 120, marginTop: "10px" }}
              onChange={props.handleYearChange}
            >
              <Select.Option value="2017-18">2017-18</Select.Option>
              <Select.Option value="2018-19">2018-19</Select.Option>
              <Select.Option value="2019-20">2019-20</Select.Option>
              <Select.Option value="2020-21">2020-21</Select.Option>
              <Select.Option value="2021-22">2021-22</Select.Option>
              <Select.Option value="2022-23">2022-23</Select.Option>
              <Select.Option value="2023-24">2023-24</Select.Option>

            </Select>
          </div>
        </Modal>

        <Modal
          title={

            (props.supplierInvoices.length === 0
              ? "No"
              : props.supplierInvoices.length) +
            " Invoice(s) filed by " +

            props.vendorGstname +
            " for FY " +
            props.queryModalYearSelection
          }
          // title={this.getModalTitle}
          visible={props.visibleModal}
          onCancel={props.hideModal}
          footer={null}
          width="96%"
        >
          <SRow gutter={24} style={row_style}>
            <Col span="4">
              Total Invoice Value:{" "}
              {formatNumber(
                reduce((curr, next) => {
                  curr =
                    parseFloat(curr) +
                    parseFloat(
                      next.invoice_value ? next.invoice_value : "0",
                      2
                    );
                  var temp = parseFloat(curr);
                  temp = parseFloat(temp).toFixed(2);
                  return temp;
                }, 0)(props.supplierInvoices)
              )}
            </Col>
            <Col span="4">
              Total Taxable Value:{" "}
              {formatNumber(
                flow(
                  flatMap(get("recon_pr_b2b_items")),
                  reduce((curr, next) => {
                    curr =
                      parseFloat(curr) +
                      parseFloat(
                        next.taxable_value ? next.taxable_value : "0",
                        2
                      );
                    var temp = parseFloat(curr);
                    temp = parseFloat(temp).toFixed(2);
                    return temp;
                  }, 0)
                )(props.supplierInvoices)
              )}
            </Col>
            <Col span="4">
              Total IGST Value:{" "}
              {formatNumber(
                flow(
                  flatMap(get("recon_pr_b2b_items")),
                  reduce((curr, next) => {
                    curr =
                      parseFloat(curr) +
                      parseFloat(next.igst ? next.igst : "0", 2);
                    var temp = parseFloat(curr);
                    temp = parseFloat(temp).toFixed(2);
                    return temp;
                  }, 0)
                )(props.supplierInvoices)
              )}
            </Col>
            <Col span="4">
              Total CGST Value:{" "}
              {formatNumber(
                flow(
                  flatMap(get("recon_pr_b2b_items")),
                  reduce((curr, next) => {
                    curr =
                      parseFloat(curr) +
                      parseFloat(next.cgst ? next.cgst : "0", 2);
                    var temp = parseFloat(curr);
                    temp = parseFloat(temp).toFixed(2);
                    return temp;
                  }, 0)
                )(props.supplierInvoices)
              )}
            </Col>
            <Col span="4">
              Total SGST Value:{" "}
              {formatNumber(
                flow(
                  flatMap(get("recon_pr_b2b_items")),
                  reduce((curr, next) => {
                    curr =
                      parseFloat(curr) +
                      parseFloat(next.sgst ? next.sgst : "0", 2);
                    var temp = parseFloat(curr);
                    temp = parseFloat(temp).toFixed(2);
                    return temp;
                  }, 0)
                )(props.supplierInvoices)
              )}
            </Col>
            <Col span="4">
              Total CESS Value:{" "}
              {formatNumber(
                flow(
                  flatMap(get("recon_pr_b2b_items")),
                  reduce((curr, next) => {
                    curr =
                      parseFloat(curr) +
                      parseFloat(next.cess ? next.cess : "0", 2);
                    var temp = parseFloat(curr);
                    temp = parseFloat(temp).toFixed(2);
                    return temp;
                  }, 0)
                )(props.supplierInvoices)
              )}
            </Col>
          </SRow>
          <Table
            title={props.getModalTitle}
            dataSource={props.supplierInvoices}
            bordered
            footer={() => (
              <div style={{ textAlign: "center" }}>
                <Button
                  icon="download"
                  style={{ backgroundColor: "#2382c7", color: "white" }}
                  onClick={() => props.RFT_Excel(props.supplierInvoices)}
                >
                  Download as Excel
                </Button>
              </div>
            )} onDropSR
            locale={{ emptyText: "No invoices found!" }}
            rowKey="id"
          >
            <Column
              title="Invoice Number"
              dataIndex="invoice_number"
              className="alignCenter"
              key="invoice_number"
              filterDropdown={({
                setSelectedKeys,
                selectedKeys,
                confirm,
                clearFilters
              }) => (
                <div className="custom-filter-dropdown">
                  <Input
                    placeholder="Search Invoice Number"
                    value={selectedKeys[0]}
                    onChange={e =>
                      setSelectedKeys(e.target.value ? [e.target.value] : [])
                    }
                    onPressEnter={props.handleSearch(selectedKeys, confirm)}
                  />
                  <Button
                    type="primary"
                    onClick={props.handleSearch(selectedKeys, confirm)}
                  >
                    Search
                  </Button>
                  <Button
                    id="InvoiceSearch"
                    onClick={props.handleReset(clearFilters)}
                  >
                    Reset
                  </Button>
                </div>
              )}
              filterIcon={filtered => (
                <Icon
                  type="search"
                  style={{ color: filtered ? "#108ee9" : "#aaa" }}
                />
              )}
              onFilter={(value, record) =>
                record.invoice_number
                  .toLowerCase()
                  .includes(value.toLowerCase())
              }
              render={text => {
                return props.searchText ? (
                  <span>
                    {text
                      .split(
                        new RegExp(
                          `(?<=${props.searchText})|(?=${props.searchText
                          })`,
                          "i"
                        )
                      )
                      .map(
                        (fragment, i) =>
                          fragment.toLowerCase() ===
                            props.searchText.toLowerCase() ? (
                            <span key={i} className="highlight">
                              {fragment}
                            </span>
                          ) : (
                            fragment
                          ) // eslint-disable-line
                      )}
                  </span>
                ) : (
                  text
                );
              }}
            />
            {/*<Column
                        title="GSTIN"
                        dataIndex="supplier_gstin"
                        className="alignCenter"
                        key="supplier_gstin"                        
                      />*/}
            <Column
              title="Invoice Date"
              dataIndex="invoice_date"
              className="alignCenter"
              key="invoice_date"
              defaultSortOrder="descend"
              sorter={(a, b) => props.sortDate(a.invoice_date, b.invoice_date)}
              render={text =>
                text ? moment(text, "DD-MM-YYYY").format("DD-MMM-YY") : ""
              }
            />
            <Column
              title="Invoice Value"
              dataIndex="invoice_value"
              className="alignCenter"
              key="invoice_value"
              render={val => <p>{formatNumber(val === null ? 0 : val)}</p>}
            />
            <Column
              title="Invoice Type"
              dataIndex="invoice_type"
              className="alignCenter"
              key="invoice_type"
            />
            <Column
              title="POS"
              dataIndex="pos_id"
              className="alignCenter"
              key="pos_id"
              render={pos => pos ?
                getPlaceOfSupply(pos.substring(0, 2)) : null
              }
            />
            <Column
              title="Reverse Charge"
              dataIndex="reverse_charge"
              className="alignCenter"
              key="reverse_charge"
            />

            <Column
              title="Items"
              key="action"
              className="alignCenter"
              rowSpan="2"
              render={(text, record, index) => {
                var but = (
                  <SRow gutter={24} style={{ textAlign: "center" }}>
                    <Col span="8">
                      <Button
                        icon="bars"
                        type="primary"
                        onClick={() => props.showItemModal(record)}
                      >
                        Items
                      </Button>
                      <Modal
                        title="List Items Summary"
                        visible={
                          props.visibleItemModal === record.id
                            ? true
                            : false
                        }
                        onCancel={props.hideItemModal}
                        footer={null}
                        width="920"
                      >
                        <Table
                          dataSource={record.recon_pr_b2b_items}
                          bordered
                          pagination={{
                            className: "my-pagination",
                            defaultPageSize: 6
                          }}
                        >
                          <Column
                            title="Rate"
                            dataIndex="gst_rate"
                            className="alignCenter"
                            key="gst_rate"
                          />
                          <Column
                            title="Taxable Value"
                            className="alignCenter"
                            dataIndex="taxable_value"
                            key="taxable_value"
                            render={val => (
                              <p>{formatNumber(val === null ? 0 : val)}</p>
                            )}
                          />
                          <Column
                            title="IGST"
                            dataIndex="igst"
                            className="alignCenter"
                            key="igst"
                            render={val => (
                              <p>
                                {val === null ? " - - - " : formatNumber(val)}
                              </p>
                            )}
                          />
                          <Column
                            title="CGST"
                            dataIndex="cgst"
                            className="alignCenter"
                            key="cgst"
                            render={val => (
                              <p>
                                {val === null ? " - - - " : formatNumber(val)}
                              </p>
                            )}
                          />
                          <Column
                            title="SGST"
                            dataIndex="sgst"
                            className="alignCenter"
                            key="sgst"
                            render={val => (
                              <p>
                                {val === null ? " - - - " : formatNumber(val)}
                              </p>
                            )}
                          />
                          <Column
                            title="Cess"
                            dataIndex="cess"
                            className="alignCenter"
                            key="cess"
                            render={val => (
                              <p>
                                {val === null ? " - - - " : formatNumber(val)}
                              </p>
                            )}
                          />
                        </Table>
                      </Modal>
                    </Col>
                  </SRow>
                );
                return but;
              }}
            />
          </Table>
        </Modal>
      </Content>

    </Root>
  )
}

class SalesRegisterContainer extends React.Component {
  constructor(props) {
    super(props);
    console.log(props, "props");
    var d = new Date();
    var n = d.getMonth();
    var y = d.getYear();
    var curyear = 1900 + y;
    var nextyear = curyear + 1 - 2000;
    var year = curyear + '-' + nextyear;
    this.onDropSR = this.onDropSR.bind(this);
    message.config({
      maxCount: 1,
    });
    this.state = {
      supplierInvoices: [],
      gstnName: "",
      hideModal: null,
      searchText: "",
      visibleItemModal: null,
      visibleItemModal_Customer: null,
      hideItemModal: null,
      finMonth: props.finMonth,
      finYear: props.finYear,
      curFinMonth: n + 1,
      curFinYear: year,
      companyId: props.selectedCompany,
      output: [],
      downloadLoading: false,
      resetLoading: false,
      sales_loading: false,
      pending_load: false,
      popupConfirmReset: false,
      popupConfirmPull: false,
      visible: false,
      downloadLoading: false,
      queryModal: false,
      period: null,
      queryModalYearSelection:this.props.finYear,
      visibleModal: null,
      vendorGstin: "",
      vendorGstname: "",
      // vendorcompanyid:props.Supplier_View.companyI
    }


    comp_id = props.selectedCompany;
    this.props.gstr1summary.refetch();
  }

  queryYEARPurchase = (records) => {

    this.setState({ queryModal: true, type: "purchase", vendorGstin: records.vendor_gstin, vendorGstname: records.vendor_gstname });
  };

  queryYEAR_CANCEL = type => {
    this.setState({ queryModal: false });
  };

  showItemModal = async record => {
    this.setState({ visibleItemModal: record.id });
  };

  hideItemModal = () => {
    this.setState({ visibleItemModal: false });
  };

  queryYEAR = () => {
    if (this.state.type === "purchase") {
      console.log(this.state.vendorGstin, "vendor");
      this.showSupplierInvoicesModal();
    }
  };

  handleDownload  = () => {

    let sliceSize = 1024;
    let byteCharacters = atob(EXCEL_FILE_BASE64);
    let bytesLength = byteCharacters.length;
    let slicesCount = Math.ceil(bytesLength / sliceSize);
    let byteArrays = new Array(slicesCount);
    for (let sliceIndex = 0; sliceIndex < slicesCount; ++sliceIndex) {
      let begin = sliceIndex * sliceSize;
      let end = Math.min(begin + sliceSize, bytesLength);
      let bytes = new Array(end - begin);
      for (var offset = begin, i = 0; offset < end; ++i, ++offset) {
        bytes[i] = byteCharacters[offset].charCodeAt(0);
      }
      byteArrays[sliceIndex] = new Uint8Array(bytes);
    }
    FileSaver.saveAs(
      new Blob(byteArrays, { type: "application/vnd.ms-excel" }),
      "SupplierView.xls"
    );
    
  };

 
  RFT_Excel = async b2b => {
    const excelOutput = await excelUtility.RFT_Excel(b2b);

    if (excelOutput.status === "EMPTYSHEET") {
      message.warning("No invoices available to download!");
    }
  };

  showSupplierInvoicesModal = () => {
    message.destroy();
    message.loading("Searching Supplier Invoices....", 0);



    var downloaddate =
      this.props.finMonth + "/" + this.state.queryModalYearSelection;

    const getInvoices = fetch(
      `${BASE_URL}/export/getSupplierInvoices?gstin=${this.state.vendorGstin
      }&companyId=${this.props.selectedCompany}&downloaddate=${downloaddate}`,
      {
        method: "GET"
      }
    )
      .then(res => res.json())
      .then(result => {
        // console.log("=======DATA=====");
        // console.log(result);

        this.setState({ supplierInvoices: result });

        message.destroy();

        this.setState({ visibleModal: true, queryModal: false });
      });
  };
  handleYearChange = val => {
    this.setState({ queryModalYearSelection: val });
    console.log("select yaar",val)
  };

  hideModal = () => {
    this.setState({ visibleModal: false });
    document.getElementById("InvoiceSearch").click();
  };


  getModalTitle = () => {
    return (
      <p>
        <b>
          B2B Data{" "}
          {this.state.vendorGstname === "" ? "" : " for " + this.state.vendorGstname}
        </b>
      </p>
    );
  };

  SupplierTitle = () => {
    return (
      <p>
        <b>
         SUPPLIER GSTIN DETAILS
        </b>
      </p>
    );
  };


  sortDate = (a, b) => {
    const firstDateArray = a.split("-");
    const secondDateArray = b.split("-");

    return (
      new Date(firstDateArray[2], firstDateArray[1], firstDateArray[0]) -
      new Date(secondDateArray[2], secondDateArray[1], secondDateArray[0])
    );
  };




  otherGSTNInformation = companyDetails => {
    const state_cd = companyDetails["gstin"].substr(0, 2);
    companyDetails["state"] = state_cd;
    return companyDetails;
  };

  handleSearch = (selectedKeys, confirm) => () => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  }

  handleReset = clearFilters => () => {
    clearFilters();
    this.setState({ searchText: '' });
  }

  hide = () => {
    this.setState({
      visible: false
    });
  };

  handleVisibleChange = visible => {
    this.setState({ visible });
  };
  resetSales = () => {
    this.setState({ resetLoading: true });
    console.log(this.state.vendorGstin, "vendor");
    var downloaddate = this.state.finMonth + '/' + this.state.finYear;
    fetch(`${BASE_URL}/export/supplierviewrest?from=sales&companyId=${this.state.companyId}`,
      {
        method: 'GET',
      })
      .then((result) => {
        console.log(result);
        this.setState({ resetLoading: false });
        this.props.data.refetch();
        this.props.gstr1summary.refetch()
        message.success('All Sales have been reset for selected tax period');
      })
  }
  onDropSR = async acceptedFiles => {
    //tgPlease select Financial Year to proceed
    var el = document.body,
      elChild = document.createElement('div');
    elChild.className = "root_div";
    elChild.innerHTML = '<div class="custom_loading loader"></div>';
    el.insertBefore(elChild, el.firstChild);
    document.getElementById('root').classList.add("blur");
    const result = await SUPPLIERVIEW.upload({
      file: acceptedFiles[0],
      type: 'supplierview',
      companyId: this.props.selectedCompany,
      isSR: this.props.isSR,
      finMonth: this.state.finMonth,
      finYear: this.state.finYear,
    })
    document.body.getElementsByClassName("root_div")[0].remove();  // Get the <ul> element with id="myList"
    document.getElementById('root').classList.remove('blur');
    console.log('DATA FROM UPLOAD');
    console.log(result);

    if ((result.error_status !== '') && (result.error_status !== undefined)) {
      //document.getElementById('sales_error_status').click();
      console.log('-----------------ERROR REPORT----------------');
      console.log(result.error_status);
      console.log('---------------------------------------------');
    }
    if (result.filestatus === true) {
      if (result.flag === true) {
        var dialogue_msg = '<div style="width: 20%; float:left"><img src="https://media.giphy.com/media/mh0zdNnHBV7z2/giphy.gif"/ style="width:90%;border: solid 1px #d0d0d0;border-radius: 25px 0px 25px 0px;"></div ><div style="width: 80%;"><br><p><h4> ( <span><b style="font-size: 12px;color: #0cde26;">' + result.total_errors + ' Invoices Failed out of ' + result.total + ' Invoices</b></span>) Suppler details partially saved!</h4></p><br><p>Error Excel will be downloaded. Please check and correct the Errors!</p></div>';
        var div = document.getElementById('dialogue_append1');
        if (document.getElementById('dialogue_append1') !== null) {
          div.innerHTML += dialogue_msg;
        }
      }
      /************************************************************************************/
      if (result.total_errors > 0) {
        //message.error('(' + total_negative + '/' + result.total + ') Purchase data upload Failed!')
      }
      else {
        message.success('(' + result.total + '/' + result.total + ') Vendor list uploaded successfully!', 8)
      }
      this.props.data.refetch()
      this.props.gstr1summary.refetch()
    } else if (result.file === false) {
      message.error('Uploaded file is not in Taxrecon Excel format!', 5)
    } else {
      message.error('Upload File Type is Not Allowed', 10)
    }

  }
  changeSelectedFinancialMonth = name => {
    this.props.changeSelectedFinancialMonth(name)
  }

  popupConfirmResetVisibleChange = e => {
    if (!e) {
      this.setState({ popupConfirmReset: false });
      return;
    }
    if (this.props.company) {
      if (this.props.company.role === "admin") {
        this.setState({ popupConfirmReset: false })
      } else {
        this.setState({ popupConfirmReset: true })
      }
    }
  }



  render() {
    //console.log(this.props,"this.props.data");
    return (
      <div style={{ backgroundColor: '#fff', padding: '5px' }}>
        <SalesRegister
          sr_ret_period_masters={get('viewer.sr_ret_period_masters.edges')(this.props.data)}
          supplier={get('viewer.supplier_view.edges')(this.props.data)}
          role={get('company.role', this.props)}
          finMonth={this.state.finMonth}
          queryModal={this.state.queryModal}
          queryYEARPurchase={this.queryYEARPurchase}
          queryYEAR_CANCEL={this.queryYEAR_CANCEL}
          queryYEAR={this.queryYEAR}
          visibleModal={this.state.visibleModal}
          hideModal={this.hideModal}
          visibleItemModal={this.state.visibleItemModal}
          hideItemModal={this.hideItemModal}
          showItemModal={this.showItemModal}
          getModalTitle={this.getModalTitle}
          RFT_Excel={this.RFT_Excel}
          sortDate={this.sortDate}
          vendorGstname={this.state.vendorGstname}
          finYear={this.state.finYear}
          showConfirm={this.showConfirm}
          onDropSR={this.onDropSR}
          handleSearch={this.handleSearch}
          handleReset={this.handleReset}
          supplierInvoices={this.state.supplierInvoices}

          handleDownload = {this.handleDownload}

          handleYearChange={this.handleYearChange}

          loading={this.props.data.networkStatus < 7}

          sales_loading={this.state.sales_loading}

          pending_load={this.state.pending_load}
          queryModalYearSelection={this.state.queryModalYearSelection}
          output={this.state.output}
          SupplierTitle={this.SupplierTitle}
          downloadLoading={this.state.downloadLoading}
          resetSales={this.resetSales}
          resetPurchase={this.resetPurchase}
          resetLoading={this.state.resetLoading}
          popupConfirmResetVisibleChange={this.popupConfirmResetVisibleChange}
          popupConfirmReset={this.state.popupConfirmReset}
        />
      </div>
    )

  }
}

const queryConfig = {
  options: props => ({
    variables: {
      companyId: props.selectedCompany,
      finmonth: props.finMonth.toString(),
      finyear: props.finYear,
    },
  }),
}



const config = {
  name: "gstr1summary",
  options: props => ({
    variables: {
      companyId: props.selectedCompany,
      finmonth: props.finMonth.toString(),
      finyear: props.finYear
    }
  }),
  props: ({ gstr1summary, ownProps }) => {
    return {
      gstr1summary: gstr1summary,
    };
  }
};


//2B

const companyQueryConfig = {
  options: props => ({ variables: { companyId: props.selectedCompany } })
}


const mapStateToProps = state => {
  return {
    selectedCompany: state.local.selectedCompany,
    finMonth: state.local.finMonth,
    finYear: state.local.finYear,
    output: state.output,

  }
}

export default compose(
  connect(mapStateToProps,
    {
      setGspToken: gspActions.setGspToken,
      setGspOtp: gspActions.setGspOtp,

    }),
  graphql(gql(GSTR1_Query), config),

  graphql(gql(SR_RET_Period_Query), queryConfig),
  graphql(gql(Supplier_View), companyQueryConfig)
)(SalesRegisterContainer)
